import PropTypes from 'prop-types';
import React from 'react';
import ResponsiveVideo from '../../../Elements/ResponsiveVideo/ResponsiveVideo';
import { videoTypes } from '../../../../utilities/ui_utilities';
import './VideoPlayer.scss';

export default class VideoPlayer extends React.PureComponent {
    renderYouTubeVideo() {
        return (
            <iframe
                title="company video"
                className="youtube-video"
                src={this.props.videoSrc}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
            />
        );
    }

    renderCloundinaryVideo() {
        const { responsiveVideoProps, videoSrc } = this.props;
        return (
            <ResponsiveVideo
                {...responsiveVideoProps}
                cloudinaryID={videoSrc}
                enableAutoResizing={false}
            />
        );
    }

    render() {
        const iframeClass =
            this.props.videoType === videoTypes.YOUTUBE
                ? 'iFrame-container'
                : '';
        return (
            <div
                className={`component-CompanyPages-Sections-VideoPlayer ${iframeClass} ${
                    this.props.fullWidth ? 'full-width' : ''
                }`}
            >
                {this.props.videoType === videoTypes.YOUTUBE
                    ? this.renderYouTubeVideo()
                    : this.renderCloundinaryVideo()}
            </div>
        );
    }
}

VideoPlayer.propTypes = {
    videoType: PropTypes.oneOf([videoTypes.CLOUDINARY, videoTypes.YOUTUBE])
        .isRequired,
    videoSrc: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    responsiveVideoProps: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
        emitMetric: PropTypes.bool,
    }),
};

VideoPlayer.defaultProps = {
    fullWidth: false,
    responsiveVideoProps: {
        width: 1600,
        height: 900,
    },
};
